import React from "react";
import { createPortal } from "owa-react-dom";
import loc from "owa-localize";
import { observer } from "owa-mobx-react";
import { StatusBarTargetContext } from "./StatusBarTargetContext";
import { itemsLabel, itemsTooltip, unreadLabel, unreadTooltip } from "./StatusBar.locstring.json";
import { statusBarFields } from "./StatusBar.scss";
import { useStatusBarCustomization } from "./StatusBarCustomizationContext";

type StatusBarCountsProps = {
    items: number;
    unread?: number;
};

/** Renders item and unread counts in the shared status bar through a portal. */
export const StatusBarCounts: React.FunctionComponent<StatusBarCountsProps> = observer(function StatusBarCounts({ items, unread }) {
    const target = React.useContext(StatusBarTargetContext);
    const { visibility, updateCounts } = useStatusBarCustomization();
    // Publish counts even when their status-bar fields are hidden so the menu stays current.
    React.useEffect(() => {
        updateCounts({ items, unread });
    }, [items, unread, updateCounts]);
    // Clear the previous module's counts on unmount so they do not leak into another module.
    React.useEffect(() => () => updateCounts({}), [updateCounts]);
    if (!target || (!visibility.items && (!visibility.unread || unread === undefined))) {
        return null;
    }
    
    return createPortal(<div className={statusBarFields}>
                {visibility.items && (<span role="status" title={loc(itemsTooltip)}>
                        {loc(itemsLabel, items)}
                    </span>)}
                {visibility.unread && unread !== undefined && (<span role="status" title={loc(unreadTooltip)}>
                        {loc(unreadLabel, unread)}
                    </span>)}
            </div>, target);
}, "StatusBarCounts");
